var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-collapsable", {
    attrs: {
      headerClass: "yellow darken-2 white--text",
      dialogClass: "poker",
      dialogProp: _vm.dialog,
    },
    scopedSlots: _vm._u([
      {
        key: "visible",
        fn: function () {
          return [
            _c("progress-countdown", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.asta_settings.timeout_s,
                  expression: "asta_settings.timeout_s",
                },
              ],
              ref: "timer_speaker",
              attrs: { time: _vm.asta_settings.timeout_s, name: "poker" },
              on: {
                timeover: _vm.timeoverSpeaker,
                timeStep: _vm.setSpeakerTimeLeft,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "title",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.migliore_offerta.vincitore
                    ? "Vuoi rilanciare?"
                    : "Vuoi fare offerta?"
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.asta_round && _vm.calciatoreInAsta
              ? _c("calciatore-battuto", {
                  attrs: { id: _vm.calciatoreInAsta, xLarge: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("squadra-offerta", {
                  staticClass: "mt-4",
                  attrs: {
                    offerta: _vm.migliore_offerta.offerta,
                    uid: _vm.migliore_offerta.vincitore,
                    ifNoOfferta: "Nessuna offerta",
                    variant: "horizontal",
                    creditiGlow: "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-center flex-wrap pa-3" },
              [
                _vm.migliore_offerta.vincitore
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ma-1",
                        attrs: { depressed: "", rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setRilancio(1)
                          },
                        },
                      },
                      [_vm._v("+1")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.migliore_offerta.vincitore && _vm.maxRilancio > 1
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ma-1",
                        attrs: { depressed: "", rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setRilancio(_vm.maxRilancio)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        +" + _vm._s(_vm.maxRilancio) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.migliore_offerta.vincitore
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ma-1",
                        attrs: { depressed: "", rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setOffertaCustom(_vm.minOfferta)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.minOfferta))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.maxOfferta > 1,
                        expression: "maxOfferta > 1",
                      },
                    ],
                    staticClass: "ma-1",
                    attrs: {
                      depressed: "",
                      rounded: "",
                      color: "primary",
                      id: "numpad-btn",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showNumpad()
                      },
                    },
                  },
                  [_vm._v("...")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-1",
                    attrs: {
                      depressed: "",
                      rounded: "",
                      color: "primary",
                      text: "",
                    },
                    on: { click: _vm.setPasso },
                  },
                  [_vm._v("Passo")]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.squadra(_vm.user_uid)
              ? _c(
                  "div",
                  { staticClass: "pa-4" },
                  [
                    _c("squadra-info-panel", {
                      attrs: { id_squadra: _vm.user_uid },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "px-4 pb-4" },
                  [
                    _c(
                      "v-list",
                      {
                        staticClass:
                          "recycle-scroller navy darken-2 pb-2 rounded",
                        class: { "nice-scroll": !_vm.is_mobile },
                      },
                      [
                        _c("div", { staticClass: "text-center py-2" }, [
                          _vm._v("Pianificazione ruolo"),
                        ]),
                        _vm._v(" "),
                        _c("asta-consiglio"),
                        _vm._v(" "),
                        _vm._l(
                          _vm.myPlan[_vm.ruolo_abc],
                          function (slotData, slot, i) {
                            return _c("asta-slot", {
                              key: _vm.ruolo_abc + "_" + slot,
                              attrs: {
                                ruolo_abc: _vm.ruolo_abc,
                                iSlot: slot,
                                i: i,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }